/* eslint-disable */
import React, { useContext, useState } from "react";
import { FaWindowClose } from "react-icons/fa";
import { ApiContext } from "../apiContext";
import { Card, CardBody, Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";

const ViewInvestor = ({ Modalclose, modalData }) => {
  const { data } = useContext(ApiContext);
  const [openAccordion, setOpenAccordion] = useState("");

  if (!modalData) return null;

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? "" : id);
  };

  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>INVESTOR DETAILS</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <section className="view-blog view-sec">
                <div className="container">
                  <div className="mt-3 view-text">
                    <label className="heading">Title</label>
                    <p>{modalData.title}</p>

                    {modalData.description && (
                      <>
                        <label className="heading">Description</label>
                        <p>{modalData.description}</p>
                      </>
                    )}

                   

                  {/* Accordions */}
                  {modalData.accordions && modalData.accordions.map((accordion, index) => {
                    const accordionId = `acc-${index}`;
                    return (
                      <Accordion key={accordionId} open={openAccordion} toggle={() => toggleAccordion(accordionId)} className="mt-4">
                        <AccordionItem>
                          <AccordionHeader targetId={accordionId}>
                            {accordion.title}
                          </AccordionHeader>
                          <AccordionBody accordionId={accordionId}>
                            {accordion.documents && accordion.documents.length > 0 ? (
                             <div className="document-list">
  {accordion.documents.map((doc, docIndex) => (
    <div key={docIndex} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
      <div className="doc-name">{doc.name}</div>
      <a
        href={doc.fileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-danger btn-sm"
      >
        View PDF
      </a>
    </div>
  ))}
</div>

                            ) : (
                              <p>No documents available.</p>
                            )}
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                    );
                  })}
                   <label className="heading">Status</label>
                    <div className="status-details">
                      <span className={`status ${modalData.status ? "active" : "inactive"}`}>
                        {modalData.status ? "active" : "inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ViewInvestor;
